module.exports = __webpack_public_path__ + "img/folder1.d12a1200.png";